export const HAKLAI_CALC_VIEW_LABELS = Object.freeze({
  analyzeDeal: "נתח עסקה",
  save: "שמירה"
});

export const HAKLAI_CALC_VIEW_MESSAGE_TOKENS = Object.freeze({
  pre1997Construction: ["1.4.1997", "01/04/1997"],
  propertyDepreciation: [
    "פחת",
    "מסלול מיסוי",
    "תקופת השכרה",
    "תקופת ההשכרה",
    "תאריך התחלה",
    "תאריך סיום",
    "תאריך הרכישה הרלוונטי",
    "טווחי התאריכים"
  ],
  usdRate: ["שער דולר"],
  propertyPartsTotalMismatch: ["סכום שוויי החלקים"],
  expense: ["ניכוי", "הוצאה"],
  purchase: ["רכישה"],
  form11Depreciation: ['טופס י"א', "סכום פחת"],
  propertyPartsDepreciation: ["פחת במרכיבי", "נתוני פחת"],
  propertyParts: ["חלק", "שווי", "מרכיבי הנכס"],
  grossUp: ["גילום"],
  prisa: ["פריסה", "זיכוי"]
});

export const hasHaklaiCalcViewMessageToken = (message = "", tokens = []) => (
  tokens.some((token) => message.includes(token))
);
